import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/PeaceGardens";

const PeaceGardens = () => {
  const project_id = "PRJ00073";
  const title = "Peace Gardens - Konza";

  const mapConfig = {
    minZoom: 14,
    zoom: 16,
    bounds: [
      [-1.35029, 36.59869],
      [-1.36335, 36.60627],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={project_id}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      // Legacy links were incorrect. Placeholder for correct links.
      viewProjectLink={null}
      fillOfferLink={null}
    />
  );
};

export default PeaceGardens;
